import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vendorOrders: [],
  allOrders: [],
  returnOrders: [], 
  paymentDetails: [],
  paymentDetailsByAdmin: [],
  loading: false,
  returnLoading: false,
  error: null,
  success: false,
  updating: false,
  returnUpdating: false, 
};

const vendorSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    // Get all vendor orders
    getVendorOrdersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getVendorOrdersSuccess(state, action) {
      state.loading = false;
      state.vendorOrders = action.payload;
      state.success = true;
    },
    getVendorOrdersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get payment details
    getPaymentDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getPaymentDetailsSuccess(state, action) {
      state.loading = false;
      state.paymentDetails = action.payload;
      state.success = true;
    },
    getPaymentDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get payment details By Admin
    getPaymentDetailsByAdminStart(state) {
      state.loading = true;
      state.error = null;
    },
    getPaymentDetailsByAdminSuccess(state, action) {
      state.loading = false;
      state.paymentDetailsByAdmin = action.payload;
      state.success = true;
    },
    getPaymentDetailsByAdminFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update delivery status
    updateDeliveryStatusStart(state) {
      state.updating = true;
      state.error = null;
    },
    updateDeliveryStatusSuccess(state, action) {
      state.updating = false;
      const { orderId, deliveryStatus } = action.payload;
      
      const allOrderIndex = state.allOrders.findIndex(
        order => order.OrderId === orderId
      );
      if (allOrderIndex !== -1) {
        state.allOrders[allOrderIndex].deliveryStatus = deliveryStatus;
      }
      
      state.success = true;
    },
    updateDeliveryStatusFailure(state, action) {
      state.updating = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get all orders (admin)
    getAllOrdersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getAllOrdersSuccess(state, action) {
      state.loading = false;
      state.allOrders = action.payload.data || action.payload;
      state.success = true;
    },
    getAllOrdersFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Get return orders
    getReturnOrdersStart(state) {
      state.returnLoading = true;
      state.error = null;
    },
    getReturnOrdersSuccess(state, action) {
      state.returnLoading = false;
      state.returnOrders = action.payload.data || action.payload;
      state.success = true;
    },
    getReturnOrdersFailure(state, action) {
      state.returnLoading = false;
      state.error = action.payload;
      state.success = false;
    },

    // Update return status
    updateReturnStatusStart(state) {
      state.returnUpdating = true;
      state.error = null;
    },
    updateReturnStatusSuccess(state, action) {
      state.returnUpdating = false;
      const { orderId, action: returnAction } = action.payload;
      
      // Update return status in return orders
      const returnOrderIndex = state.returnOrders.findIndex(
        order => order.OrderId === orderId
      );
      if (returnOrderIndex !== -1) {
        state.returnOrders[returnOrderIndex].returnStatus = 
          returnAction === 'approve' ? 'Approved' :
          returnAction === 'reject' ? 'Rejected' :
          returnAction === 'complete' ? 'Completed' : 'Requested';
      }
      
      state.success = true;
    },
    updateReturnStatusFailure(state, action) {
      state.returnUpdating = false;
      state.error = action.payload;
      state.success = false;
    },

    // Reset state
    resetVendorState(state) {
      state.loading = false;
      state.returnLoading = false;
      state.updating = false;
      state.returnUpdating = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  getVendorOrdersStart,
  getVendorOrdersSuccess,
  getVendorOrdersFailure,
  getPaymentDetailsStart,
  getPaymentDetailsSuccess,
  getPaymentDetailsFailure,
  updateDeliveryStatusStart,
  updateDeliveryStatusSuccess,
  updateDeliveryStatusFailure,
  getAllOrdersStart,
  getAllOrdersSuccess,
  getAllOrdersFailure,
  getReturnOrdersStart,
  getReturnOrdersSuccess,
  getReturnOrdersFailure,
  updateReturnStatusStart,
  updateReturnStatusSuccess,
  updateReturnStatusFailure,
  resetVendorState,
  getPaymentDetailsByAdminStart,
  getPaymentDetailsByAdminSuccess,
  getPaymentDetailsByAdminFailure,
} = vendorSlice.actions;

export default vendorSlice.reducer;